import { all, call, put, takeLatest } from "redux-saga/effects"

import { generateTree } from "utils/utils"

import { GET_DIMENSIONS_WATCHER } from "./constants"
import { getDimensionsSuccess, getDimensionsFailed } from "./actions"
import {
  getDimensionsApi,
  getQuestionsApi,
} from "../../../utils/routes/routes-report"

export function* getDimensionsSaga(action) {
  try {
    const dataStatus = action.payload
    const [dimensionsData, { data: questionsApi }] = yield all([
      call(getDimensionsApi, dataStatus),
      call(getQuestionsApi, dataStatus),
    ])

    const {
      data: dimensionsApi,
      metric_total: metricTotal,
      show_dimension_benchmark: showDimensionBenchmark,
    } = dimensionsData

    let questions = questionsApi
    if (questions.error != "No data") {
      questions.map((e) => {
        e.id = parseInt(
          e.id_dimension + Math.floor(Math.random() * 1000000 + 1)
        )
      })
    } else {
      questions = []
    }

    let dimensions = dimensionsApi
    if (dimensions.error === "No data") {
      dimensions = []
    }

    const result = {}
    result.metric_total = metricTotal
    result.show_dimension_benchmark = showDimensionBenchmark
    result.dimensions_drill_down = generateTree("id", "id_parent", [
      ...JSON.parse(JSON.stringify(dimensions)),
      ...JSON.parse(JSON.stringify(questions)),
    ])
    if (dataStatus.is_engagement) {
      result.metric_total.name = "Resultado total"
      result.metric_total.first = true
      result.dimensions_drill_down.unshift(result.metric_total)
    }

    yield put(getDimensionsSuccess(result))
  } catch (e) {
    yield put(getDimensionsFailed())
  }
}

export default function* widgetResultByDimensionAmbassadorV2Saga() {
  yield takeLatest(GET_DIMENSIONS_WATCHER, getDimensionsSaga)
}
